import { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import { useSelector } from "react-redux";
import { getDisplayMessages, getLocale } from "@store/lang/langSlice";
import ptBR from "../misc/translations/pt-BR.json";

const FALLBACK_LOCALE = "pt-BR";

export default function IntlWrapper({ children }: Readonly<{ children: React.ReactNode }>) {
  const reduxLocale = useSelector(getLocale);
  const reduxMessages = useSelector(getDisplayMessages);

  const [locale, setLocale] = useState(FALLBACK_LOCALE);
  const [messages, setMessages] = useState<Record<string, string>>(ptBR);

  useEffect(() => {
    if (reduxLocale && reduxMessages) {
      setLocale(reduxLocale);
      setMessages({ ...ptBR, ...reduxMessages });
    }
  }, [reduxLocale, reduxMessages]);

  return (
    <IntlProvider locale={locale} messages={messages} defaultLocale={FALLBACK_LOCALE} onError={() => {}}>
      {children}
    </IntlProvider>
  );
}
